export default __webpack_public_path__ + "static/media/pizza.4b4c4dec.png";